export enum BaseRejectionReasons {
  notCompleted = 'Not Completed',
  missingDocumentation = 'Missing Documentation',
  illegibleDocumentation = 'Illegible Documentation',
  incorrectDocumentation = 'Incorrect Documentation',
}
